import { render, staticRenderFns } from "./MessageText.vue?vue&type=template&id=004b7893&"
import script from "./MessageText.vue?vue&type=script&lang=js&"
export * from "./MessageText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports